import React, { useState, useEffect ,useMemo} from 'react';
import axios from 'axios';
import axiosInstance, { weburl } from '../../../axiosInstance'; import { Link, useNavigate, useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import Select from 'react-select';
import LoadingScreen from '../../components/LoadingScreen';
import { useThemeContext } from '../../../fetchdata/ThemeContext';
 
const OrderQueeView = () => {
 
    const { sendMessage, allMessages } = useThemeContext();
  
  const [currentDate, setCurrentDate] = useState("");
  const [currentTime, setCurrentTime] = useState("");
  const [currentMinutes, setCurrentMinutes] = useState(null); // <-- NEW

  const [Quee, setQuee] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const { hospital,floor } = useParams();
  const navigate = useNavigate();

  // ---- Helper to convert "HH:mm" to minutes since midnight ----
  const parseTimeToMinutes = (timeStr) => {
    if (!timeStr) return null;
    const [h, m] = timeStr.split(':').map(Number);
    if (Number.isNaN(h) || Number.isNaN(m)) return null;
    return h * 60 + m;
  };

  useEffect(() => {
    const updateDateTime = () => {
      const now = new Date();

      const dateOptions = {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
      };

      const timeOptions = {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      };

      setCurrentDate(now.toLocaleDateString(undefined, dateOptions));
      setCurrentTime(now.toLocaleTimeString(undefined, timeOptions));

      // store current time in minutes for comparison
      setCurrentMinutes(now.getHours() * 60 + now.getMinutes()); // <-- NEW
    };

    updateDateTime(); // run once immediately
    const interval = setInterval(updateDateTime, 1000);

    return () => clearInterval(interval);
  }, []);

  const getUserQuee = async () => {
    try {
      const { data } = await axiosInstance.get(`/quee-view/${hospital}/${floor??''}`);

      if (data?.success) {
        console.log('order', data);
        setQuee(data);
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
      toast.error("order Not found");
      // navigate('/all-order');
    }
  };

  useEffect(() => {
    getUserQuee();
  }, []);

  // ---- Filter orders based on current time between Ltime & Etime ----

  // const filteredOrders = useMemo(() => {
  //   if (!Quee?.orders || currentMinutes === null) return [];

  //   return Quee.orders
  //     .filter((order) => {
  //       const start = parseTimeToMinutes(order.Ltime);
  //       const end = parseTimeToMinutes(order.Etime);

  //       if (start === null || end === null) return false;

  //       // current time should be within the range [Ltime, Etime]
  //       return currentMinutes >= start && currentMinutes <= end;
  //     })
  //     // optional: sort by createdAt or orderId so tokens show in order
  //     .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
  // }, [Quee, currentMinutes]);

  

      
//  const filteredOrdersss = useMemo(() => {
//   console.log('adddata', allMessages);

//   if (!Quee?.orders || currentMinutes === null) return [];

//   // 1) All orderIds that are removed
//   const removedOrderIds = new Set(
//     allMessages
//       ?.filter(msg => msg.subType === "remove")
//       ?.map(msg => msg.orderId)
//   );

//   // 2) Get all "add" messages (these behave like orders)
//   const addedMessages = allMessages?.filter(msg => msg.subType === "add") || [];

//   // 3) Merge Quee.orders + addedMessages, but avoid duplicates by orderId
//   const orderMap = new Map();

//   // First, put all backend orders
//   Quee.orders.forEach(order => {
//     if (order?.orderId) {
//       orderMap.set(order.orderId, order);
//     }
//   });

//   // Then, put "add" messages (they can override / add)
//   addedMessages.forEach(msg => {
//     if (msg?.orderId) {
//       // msg structure is similar to order (has Ltime, Etime, orderId, etc.)
//       orderMap.set(msg.orderId, msg);
//     }
//   });

//   const finalOrders = Array.from(orderMap.values());

//   // 4) Apply remove + time filter
//   return finalOrders
//     .filter((order) => {
//       // Skip orders that are marked as removed
//       if (removedOrderIds.has(order._id) || removedOrderIds.has(order.orderId)) {
//         return false;
//       }

//       const start = parseTimeToMinutes(order.Ltime);
//       const end = parseTimeToMinutes(order.Etime);

//       if (start === null || end === null) return false;

//       // current time should be within the range [Ltime, Etime]
//       return currentMinutes >= start && currentMinutes <= end;
//     })
//     .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

// }, [Quee, currentMinutes, allMessages]);

const toDateOnly = (d) => new Date(d).toISOString().split("T")[0];


const filteredOrders = useMemo(() => {
  console.log('adddata', allMessages);

  if (!Quee?.orders || currentMinutes === null) return [];

  const today = toDateOnly(new Date());

  // removed ids
  const removedOrderIds = new Set(
    allMessages
      ?.filter(msg => msg.subType === "remove")
      ?.map(msg => msg.orderId)
  );

  // added messages
  const addedMessages = allMessages?.filter(msg => msg.subType === "add") || [];

  // merge into map
  const orderMap = new Map();

  Quee.orders.forEach(order => {
    if (order?.orderId) {
      orderMap.set(order.orderId, order);
    }
  });

  addedMessages.forEach(msg => {
    if (msg?.orderId) {
      orderMap.set(msg.orderId, msg);
    }
  });

  const finalOrders = Array.from(orderMap.values());

  return finalOrders
    .filter((order) => {
      // remove deleted
      if (removedOrderIds.has(order._id) || removedOrderIds.has(order.orderId)) {
        return false;
      }

      // ⭐ date filter: match today's date
      const orderDate = toDateOnly(order.date);
      if (orderDate !== today) return false;

      // ⭐ if it is "add" message, also ensure date matches its own msg.date
      if (order?.subType === "add" && order.date) {
        const msgDate = toDateOnly(order.date);
        if (msgDate !== today) return false;
      }

      // time filter
      const start = parseTimeToMinutes(order.Ltime);
      const end = parseTimeToMinutes(order.Etime);

      if (start === null || end === null) return false;

      return currentMinutes >= start && currentMinutes <= end;
    })
    .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

}, [Quee, currentMinutes, allMessages]);



const uniqueOrders = filteredOrders.filter(
  (order, index, self) =>
    index ===
    self.findIndex(o =>
      (typeof o.employeeId === "object" ? o.employeeId._id : o.employeeId) ===
      (typeof order.employeeId === "object" ? order.employeeId._id : order.employeeId)
    )
);


  return (
    <>
       <main class="w-100">
  
          {isLoading ? (
            <LoadingScreen/> 
          ) :
            (<> 
   <div className=" w-100">
    {/* HEADER */}
    <header className="board-header mb-4 rounded-0">
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3">
        <div className="d-flex align-items-center gap-3">
        
      <img style={{ width: 50, height: 50, color: "#0d47a1", fontWeight: 700 }}
       className="rounded bg-light d-flex align-items-center justify-content-center"
        src={`${weburl}${Quee?.hospital?.profile}`} />
           
          <div>
            <div className="clinic-name">{Quee?.hospital?.username} - {floor ?? '-'} </div>
            <div className="tagline"> Live Queue – {Quee?.hospital?.subDepartments && Quee?.hospital?.subDepartments.map((item,index) => (
            <span key={index} className='bg-dark px-2 py-1 rounded me-2 '> {item} </span>
            ))}</div>
          
          </div>
        </div>
        <div className="time-box">
      <div>{currentDate}</div>
      <div className="time">{currentTime}</div>
    </div>
      </div>
    </header>
    {/* MAIN CONTENT */}
    
<table className="table table-bordered border-primary align-middle mb-0">
  <thead className="table-dark">
    <tr>
      <th className='text-center bg-secondary'><div className='m-0 h1 fw-black'>Token</div></th>
      <th className='text-center bg-secondary'><div className='m-0 h1 fw-black'>Room</div></th>
      <th className='text-center bg-white'><div className='m-0 h1 fw-black'>Token</div></th>
      <th className='text-center bg-white'><div className='m-0 h1 fw-black'>Room</div></th>
    </tr>
  </thead>
  <tbody>
    {Array.from({ length: 6 }).map((_, i) => {

      
     const first = uniqueOrders[i];       // first column
      const second = uniqueOrders[i + 6];  // second column (next 6)
      console.log('filteredOrdersfilteredOrdersfilteredOrders',uniqueOrders)
      return (
        <tr key={i}>
          <td className='text-center bg-secondary'>
            <div className='m-0 h1 fw-black'>{first?.orderId ?? '--'}</div>
          </td>
          <td className='text-center bg-secondary'>
          <div className='m-0 h1 fw-black'> {first?.employeeId?.room ?? '--'} </div> 
          </td>
          <td className='text-center bg-white'>
            <div className='m-0 h1 fw-black'>{second?.orderId ?? '--'}</div>
          </td>
          <td className='text-center bg-white'>
            <div className='m-0 h1 fw-black'>  {second?.employeeId?.room ?? '--'}  </div> 
          </td>
        </tr>
      );
    })}
  </tbody>
</table>
 
  </div>
 
 

            </>)}

 


      </main>
    </>
  )
}

export default OrderQueeView